import type { FaireProductEntity } from "../../entity_types/product";

export const p_f7wx7hpyct: FaireProductEntity = {
  token: "p_f7wx7hpyct",
  type: "product",
  name: "Arkansas Razorbacks Paper Clip Charm Collector Necklace",
  brandToken: "b_emgllltle6",
  brandName: "Canvas Style",
  imageUrl:
    "https://cdn.faire.com/fastly/f05822363f8a28e012ee9e0948535f79203acbff08fc24ca8f25d9b50704bb05.jpeg",
  galleryImageUrls: [],
  priceDollars: 12.5,
  description:
    'The Arkansas Razorbacks Paper Clip Charm Collector Necklace in shiny gold features a trendy paper clip chain adorned with a Razorbacks charm. A stylish way to show off your team pride, this necklace is perfect for adding a touch of elegance and flair to any outfit.\n\nDETAILS\nBase Metal with Shiny Gold Plating\n16" Adjustable\nNCAA Officially Licensed',
  tags: [],
  msrpDollars: 42,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:51:40.649Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
